


export class Patternizer{
    constructor(regexpModel){
        var _regexpModel = regexpModel;

        Object.defineProperty(this,'regexpModel',{
            get : function(){ return _regexpModel },
            enumerable : true 
        });
    }

    // private 

    getIndexes(strPattern){
        return Patternizer.getIndexesSequence(this.regexpModel, strPattern);
    }
    
    test(strPattern){
        var regexp = new RegExp(this.regexpModel);
        return regexp.test(strPattern);
    }

    // public 
    getServices(strPattern){
        var ret = {};
        ret.getIndexes = () => this.getIndexes(strPattern);
        ret.getPattern = ()=>{
            var indices = ret.getIndexes();
            var pattern = '';
            indices.filter(index => pattern += strPattern[index] );
            return pattern;
        }
        ret.test = ()=>this.test(strPattern);
        return ret;
    }

    // utils
    static getIndexesSequence(regexpModel, strPattern){   // fullmatch 
        var regexp = new RegExp(regexpModel,'g');
        var matches = strPattern.matchAll(regexp);
        var set = new Set(); 
        for (const match of matches) {  
            var startIndex = match.index; 
            var endIndex = match.index + match[0].length ; // only uses the full match not the groups 
            // console.log(`Found ${match[0]}`);
            for (var i = startIndex; i <= endIndex -1 ; i++){  
                set.add(i);
            }
        }
        return [...set];   
    }


}



var regex2 = /([SH#]*)|([\*HS]#[\*HS])/g
export var summaryPattern = new Patternizer('[SH#]|[\*HS]#[\*HS]')
//export var summaryPattern = new Patternizer(/([HS])+[\*]*([\*]#[\*])*[\*]*([HS])+/g)
export var directionHSPattern = new Patternizer('H[^HS]*S');  // H->S
export var directionSHPattern = new Patternizer('S[^HS]*H');  // S->H
export var directHSPattern = new Patternizer('H[^#HS]*S');   //## COMMENT not used (tests only)

export var directHSPatternBis = new Patternizer('H[\*]*S'); 
export var directSHPatternBis = new Patternizer('S[\*]*H'); 
export var directAllHSPatternBis = new Patternizer('S[\*]*H|H[\*]*S'); //## COMMENT not used (tests only)




//TESTS
/*
var strPattern1 = '**H**#***#***S**';
console.log('summaryPattern pattern1:',strPattern1, '->',summaryPattern.getServices(strPattern1).test())
console.log('summaryPattern pattern1:',strPattern1, '->', summaryPattern.getServices(strPattern1).getIndexes())
console.log('summaryPattern pattern1:',strPattern1, '->',summaryPattern.getServices(strPattern1).getPattern())


var strPattern2 = '***S**H**';
console.log('summaryPattern pattern2:',strPattern2, '->', summaryPattern.getServices(strPattern2).getIndexes())
console.log('summaryPattern pattern2:',strPattern2, '->',summaryPattern.getServices(strPattern2).getPattern())

var strPattern3 = '***H*S**'
console.log('summaryPattern pattern3:',strPattern3, '->', summaryPattern.getServices(strPattern3).getIndexes())
console.log('summaryPattern pattern3:',strPattern3, '->',summaryPattern.getServices(strPattern3).getPattern())

var strPattern4 = 'SHS#S******'
console.log('summaryPattern pattern4:',strPattern4, '->', summaryPattern.getServices(strPattern4).getIndexes())
console.log('summaryPattern pattern4:',strPattern4, '->',summaryPattern.getServices(strPattern4).getPattern())

var strPattern5 = 'S*#****H*';
console.log('summaryPattern pattern5:',strPattern5, '->', summaryPattern.getServices(strPattern5).getIndexes())
console.log('summaryPattern pattern5:',strPattern5, '->',summaryPattern.getServices(strPattern5).getPattern())

var strPattern6 = 'S****#****H*';
console.log('summaryPattern pattern6:',strPattern6, '->', summaryPattern.getServices(strPattern6).getIndexes())
console.log('summaryPattern pattern6:',strPattern6, '->',summaryPattern.getServices(strPattern6).getPattern())

var strPattern7 = '*****H*#*H**S*';
console.log('summaryPattern pattern7:',strPattern7, '->', summaryPattern.getServices(strPattern7).getIndexes())
console.log('summaryPattern pattern7:',strPattern7, '->',summaryPattern.getServices(strPattern7).getPattern())

var strPattern8 = '**#*H**S*';
console.log('summaryPattern pattern8:',strPattern8, '->', summaryPattern.getServices(strPattern8).getIndexes())
console.log('summaryPattern pattern8:',strPattern8, '->',summaryPattern.getServices(strPattern8).getPattern())

var strPattern9 = 'S*H*****#********';
console.log('summaryPattern pattern9:',strPattern8, '->', summaryPattern.getServices(strPattern9).getIndexes())
console.log('summaryPattern pattern9:',strPattern8, '->',summaryPattern.getServices(strPattern9).getPattern())

console.log('----')
var strPattern = 'SHS#S******'; console.log(strPattern)
console.log('directHSPattern pattern:',strPattern, '->', directHSPattern.getServices(strPattern).getIndexes())
console.log('directHSPattern pattern:',strPattern, '->',directHSPattern.getServices(strPattern).getPattern())
console.log('directHSPattern pattern:',strPattern, '->',directHSPattern.getServices(strPattern).test())
console.log('directHSPattern pattern:',strPattern, '->',directHSPattern.getServices(strPattern).test()) // test 2 does not give same result !!
console.log('directHSPattern pattern:',strPattern, '->', directHSPattern.getServices(strPattern).getIndexes())

console.log('----')
var strPattern = 'H**S***H'; console.log(strPattern)
var directHSServices = directHSPattern.getServices(strPattern)
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.test())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.test()) // test 2 does not give same result !!
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getIndexes())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getPattern())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getIndexes())

console.log('----')
var strPattern = 'HSHH'; console.log(strPattern)
var directHSServices = directHSPattern.getServices(strPattern)
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.test())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.test()) // test 2 does not give same result !!
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getIndexes())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getPattern())
console.log('directHSPattern pattern:',strPattern, '->', directHSServices.getIndexes())

console.log('----')
var strPattern = 'SHS#S******'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S#*H'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'H#*S'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S****H#*H'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S****H#**S*H***S'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S****H'; console.log(strPattern)
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = '*#*HS'; console.log(strPattern);
var serv = directHSPatternBis.getServices(strPattern);
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S*H*****#********'; console.log(strPattern);
var serv = directSHPatternBis.getServices(strPattern);
console.log('directSHPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directSHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directSHPatternBis pattern:',strPattern, '->',serv.test())
console.log('directSHPatternBis pattern:',strPattern, '->',serv.test())
console.log('directSHPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directSHPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S****H#**S*H***S'; console.log(strPattern)
var serv = directAllHSPatternBis.getServices(strPattern);
console.log('directAllHSPatternBis pattern:',strPattern, '->',serv.getIndexes())
console.log('directAllHSPatternBis pattern:',strPattern, '->',serv.getPattern())
console.log('directAllHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directAllHSPatternBis pattern:',strPattern, '->',serv.test())
console.log('directAllHSPatternBis pattern:',strPattern, '->', serv.getIndexes())
console.log('directAllHSPatternBis pattern:',strPattern, '->',serv.getPattern())

console.log('----')
var strPattern = 'S****H#**S*H***S'; console.log(strPattern)
var serv = directionHSPattern.getServices(strPattern);
console.log('directionHSPattern pattern:',strPattern, '->',serv.getIndexes())
console.log('directionHSPattern pattern:',strPattern, '->',serv.getPattern())
console.log('directionHSPattern pattern:',strPattern, '->',serv.test())
console.log('directionHSPattern pattern:',strPattern, '->',serv.test())
console.log('directionHSPattern pattern:',strPattern, '->', serv.getIndexes())
console.log('directionHSPattern pattern:',strPattern, '->',serv.getPattern())
*/